import React from 'react';
import { LoadingIndicatorProps } from 'react-select/src/components/indicators';

import { Spinner } from '../../spinner.component';
import { Option } from '../option.model';

export const LoadingIndicator = ({
  innerProps,
}: LoadingIndicatorProps<Option, true>) => (
  <div className="mr-3" {...innerProps}>
    <Spinner />
  </div>
);
